import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "" }) {
  const base = "https://www.yono-studio.com";
  const fullTitle = title ? `${title} | YONO` : "YONO — Habitats bois contemporains";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${base}${path}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${base}${path}`} />
    </Helmet>
  );
}
